import { GetterTree } from 'vuex';
import { AdmpNewsState } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<AdmpNewsState, RootState> = {
  ['getAdmpNews']: (state) => state.AdmpNews,
  ['getAdmpNewsDashboard']: (state) => state.admpNewsDashboad,
  ['getAdmpNewsIsLoading']: (state) => state.AdmpNews?.isLoading,
  ['getAdmpNewsDashboardIsLoading']: (state) => state.isAdmpNewsDashboardIsLoading,
  ['getAdmpNewsTotal']: (state) => state.AdmpNews?.total,
  ['getAdmpNewsSearchParams']: (state) => state.AdmpNews?.searchParams,
  ['getAdmpNewsContactType']: (state) => state.admpNewsContactType,
  ['getAdmpNewsSearchData']: (state) => state.admpNewsSearchData,
  ['getUnreadNews']: (state) => state.unreadNews,
  ['getAdmpNewsImages']: (state) => state.admpNewsImages,
  ['isTableView']: (state) => state.isTableView,

  ['isSearchDataEmpty']: (state) => {
    const searchData = state.admpNewsSearchData;
    let hasDate = !!searchData.datum;
    let hasFavorite = searchData.favorite != undefined;
    let hasStatus = searchData.status != undefined;

    let isEmpty = !hasDate && !hasFavorite && !hasStatus;
    return isEmpty;
  },
};
